import { unwrapResult } from '@reduxjs/toolkit';
import * as React from 'react';
import Select from 'react-select';
import { Button, Col, Collapse, Row, Table } from 'reactstrap';
import AFRAssignmentDetail from '../../components/AFRAssignmentDetail';
import AFRAssignmentMaster from '../../components/AFRAssignmentMaster';
import { useAppDispatch, useAppSelector } from '../../hooks/index';
import { ReviewsRequestFilter, loadReviews, selectReviews, resetState as afrReviewResetState } from '../../redux/AfrReviewSlice';
import { resetState } from '../../redux/AfrSlice';
import { getAllAdminUsers } from '../../redux/ContactSlice';
import { EntityReference, selectEntities } from '../../redux/EntitiesSlice';
import { resetEntityState } from '../../redux/EntitySlice';
import { getReportYears, selectAvailableReportYears } from '../../redux/ReportSlice';
import { TaxonomyTypeEnum } from '../../redux/TaxonomyVersionSlice';
import Page from '../Page';
import NavigationPanelItem from '../core/NavigationPanelItem';



const ReportAssignmentCore = (props: { taxonomyType: TaxonomyTypeEnum }) => {
    const dispatch = useAppDispatch();
    const selYears = useAppSelector(selectAvailableReportYears);

    interface DropdownOption {
        label: string;
        value: string;
    }

    const emptyDropdownList: Array<DropdownOption> = [];

    const [enableFilterSection, setEnableFilterSection] = React.useState(true);
    const [showMasterDetail, setShowMasterDetail] = React.useState(false);
    const [contactList, setContactList] = React.useState(emptyDropdownList);

    const [selectedEntity, setSelectedEntity] = React.useState("---");
    const [selectedEntityType, setSelectedEntityType] = React.useState("---");
    const [selectedFiscalYear, setSelectedFiscalYear] = React.useState("---");
    const [selectedContact, setSelectedContact] = React.useState("---");
    const [filterOpen, setFilterOpen] = React.useState(true);

    const entities = useAppSelector(selectEntities);

    const afrStartYear = 2019;
    const afrEndYear = endDate();

    const getStatusFilter = function (tt: TaxonomyTypeEnum) {
        var result: string[] = [];
        switch (tt) {
            case TaxonomyTypeEnum.COURT_REPORTING_939:
                result = ["VERIFIED", "CERTIFIED_BY_ENTITY", "RE_CERTIFIED_BY_ENTITY", "RETURNED_BY_DFS","IN_PROGRESS","NOT_REPORTED"];
                break;

            default:
                result = ["VERIFIED", "CERTIFIED_BY_ENTITY", "RE_CERTIFIED_BY_ENTITY", "RETURNED_BY_DFS"];
                break;
        }
        return result;
    }

    const reviewRequestFilter: ReviewsRequestFilter = {
        entities: [],
        versionStates: getStatusFilter(props.taxonomyType),
        startYear: afrStartYear,
        endYear: afrEndYear,
        entityTypes: [],
        reviewers: [],
        taxonomyType: props.taxonomyType
    }
    const [filter, setFilter] = React.useState<ReviewsRequestFilter>(reviewRequestFilter);

    const reviewsList = useAppSelector(selectReviews);
    const firstOption = { label: "Select One", value: "---" };

    const optionsEntities = function () {
        var options: Array<DropdownOption> = [];
        options.unshift(firstOption);
        var eList: EntityReference[] = [];
        switch (props.taxonomyType) {
            case TaxonomyTypeEnum.COURT_REPORTING_29:
            case TaxonomyTypeEnum.COURT_REPORTING_939:
                eList = entities.filter((x: EntityReference) => x.code < "200000");
                break;

            case TaxonomyTypeEnum.AFR:
                eList = entities;
                break;
        }
        eList.map((entity: EntityReference) => (options.push({
            label: entity.code + " - " + entity.name,
            value: entity.code
        })));
        return options;
    }

    function endDate() {
        const d = new Date();
        return d.getFullYear();
    }

    const getFiscalYears = function () {
        let years: Array<{ value: string; label: string; }> = [];
        if (selYears && selYears.length > 0) {
            selYears.map((yr: number) => years.push({ value: yr.toString(), label: yr.toString() }));
        } else {
            const d = new Date();
            let year = d.getFullYear();
            years.push({ value: "2019", label: "2019" });

            for (let i = 2020; i <= d.getFullYear(); i++) {
                years.push({ value: i.toString(), label: i.toString() });
            }
        }
        years = years.reverse();
        years.unshift(firstOption);
        return years;
    }

    const entityTypes = function () {
        var types = [{ value: "SPECIAL_DISTRICT", label: "Special District" },
        { value: "COUNTY", label: "County" },
        { value: "CITY", label: "City" },
        { value: "OTHER_ENTITY", label: "Other - Government Finance Agency" }
        ];
        types.unshift(firstOption);
        return types;
    }

    const ddEntities = (< div >
        <Select
            value={
                optionsEntities().filter(function (option) {
                    return option.value === selectedEntity;
                })
            }
            onChange={handleEntityChange}
            options={optionsEntities()}
        />
    </div >)

    const ddFiscalYear = (< div >
        <Select
            value={
                getFiscalYears().filter(function (option: { value: string; label: string; }) {
                    return option.value === selectedFiscalYear;
                })
            }
            onChange={handleYearChange}
            options={getFiscalYears()}
        />
    </div >);

    const ddEntityType = (< div >
        <Select
            value={
                entityTypes().filter(function (option) {
                    return option.value === selectedEntityType;
                })
            }
            onChange={handleTypeChange}
            options={entityTypes()}
        />
    </div >);


    const ddContacts = (< div >
        <Select
            value={contactList &&
                contactList.filter(function (option) {
                    return option.value === selectedContact;
                })
            }
            name="CONTACTS"
            onChange={handleReviewerChange}
            options={contactList}
        />

    </div >);




    /* *****************************************************************************
     * Events and Effects
     *******************************************************************************/
    async function getContactList() {
        const resultAction = await dispatch(getAllAdminUsers())
        var originalPromiseResult: Array<DropdownOption> = unwrapResult(resultAction);
        originalPromiseResult.unshift(firstOption);
        setContactList(originalPromiseResult);
    }

    function handleReviewerChange(event: any, action: any) {
        var newFilter: ReviewsRequestFilter = { ...filter };
        newFilter.reviewers = [event.value];
        setFilter(newFilter);
        setSelectedContact(event.value);
        setShowMasterDetail(false);
        setFilterOpen(true);

    }

    function handleEntityChange(event: any, action: any) {
        var newFilter: ReviewsRequestFilter = { ...filter };
        newFilter.entities = [event.value];
        setFilter(newFilter);
        setSelectedEntity(event.value);
        setShowMasterDetail(false);
        setFilterOpen(true);
    }

    function handleYearChange(event: any, action: any) {
        var newFilter: ReviewsRequestFilter = { ...filter };
        newFilter.endYear = event.value;
        newFilter.startYear = event.value - 1;
        setFilter(newFilter);
        setSelectedFiscalYear(event.value);
        setShowMasterDetail(false);
        setFilterOpen(true);
    }

    function handleTypeChange(event: any, action: any) {
        var newFilter: ReviewsRequestFilter = { ...filter };
        newFilter.entityTypes = [event.value];
        setFilter(newFilter);
        setSelectedEntityType(event.value);
        setShowMasterDetail(false);
        setFilterOpen(true);
    }

    function handleSearch() {
        dispatch(afrReviewResetState({}));
        var newFilter: ReviewsRequestFilter = { ...filter };
        if (selectedEntity === firstOption.value) {
            newFilter.entities = [];
        }

        if (selectedEntityType === firstOption.value) {
            newFilter.entityTypes = [];
        }

        if (selectedFiscalYear === firstOption.value) {
            newFilter.startYear = afrStartYear;
            newFilter.endYear = afrEndYear;
        }

        if (selectedContact === firstOption.value) {
            newFilter.reviewers = [];
        }
        setFilterOpen(false);
        setShowMasterDetail(true);
        dispatch(resetState({}));
        dispatch(loadReviews(newFilter));
    }

    React.useEffect(() => {
        //DOING THIS TO STOP THE RECURSIVE CALLING
        dispatch(getReportYears(props.taxonomyType));
        if ((reviewsList === null) || (reviewsList.length === 0)) {
            dispatch(afrReviewResetState({}));
            /*dispatch(loadReviews(filter));*/
        }

    }, []);


    React.useEffect(() => {
        getContactList();
        setSelectedEntity(firstOption.value);
        setSelectedEntityType(firstOption.value);
        setSelectedFiscalYear(firstOption.value);
        setSelectedContact(firstOption.value);

    }, []);

    React.useEffect(() => {

        // reset the states when destroying the component
        return function cleanup() {
            console.log("Releasing resources.");
            dispatch(resetState({}));
            dispatch(resetEntityState({}));
            dispatch(afrReviewResetState({}));
        }
    }, []);

    /*******************************************************************************/
    return (
        <Page>
            <Row>
                <Col>
                    <NavigationPanelItem
                        active={enableFilterSection}
                        componentName="Search Criteria" open={filterOpen}>

                        <Table borderless >

                            <tbody>

                                <tr>
                                    <th className="col-2"><b>Search For:</b></th>
                                    <td className="col-4"></td>
                                    <td className="col-4"></td>
                                </tr>
                                <tr>
                                    <th className="col-2 text-right">Entity ID:</th>
                                    <td className="col-4">{ddEntities}</td>
                                    <td className="col-4"></td>
                                </tr>
                                {props.taxonomyType == TaxonomyTypeEnum.AFR
                                    ?
                                    <tr>
                                        <th className="col-2 text-right">Entity Type:</th>
                                        <td className="col-4">{ddEntityType}</td>
                                        <td className="col-4"></td>
                                    </tr>
                                    : <tr></tr>
                                }
                                <tr>
                                    <th className="col-2 text-right">Fiscal Year:</th>
                                    <td className="col-4">{ddFiscalYear}</td>
                                    <td className="col-4"></td>
                                </tr>
                                <tr>
                                    <th className="col-2 text-right">Assigned to:</th>
                                    <td className="col-4">{ddContacts}</td>
                                    <td className="col-4"></td>
                                </tr>
                                <tr>
                                    <th className="col-2"><Button type="button" onClick={handleSearch}>Search</Button></th>
                                    <td className="col-4"></td>
                                    <td className="col-4"></td>
                                </tr>


                            </tbody>
                        </Table>

                    </NavigationPanelItem>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Collapse isOpen={showMasterDetail == true}>
                        <AFRAssignmentMaster filteredReviewList={reviewsList} filter={filter} taxonomyType={props.taxonomyType} />
                    </Collapse>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Collapse isOpen={showMasterDetail == true}>
                        <AFRAssignmentDetail />
                    </Collapse>
                </Col>
            </Row>
        </Page>
    );
};

export default ReportAssignmentCore;